// Site Configuration
// This file controls the main categories and their display settings

// Base URL for root-domain deployment
const BASE_URL = '';

// Helper function to get correct image path with base URL
export const getImagePath = (path) => {
  return `${BASE_URL}${encodeURI(path)}`;
};

export const siteConfig = {
  // Main navigation categories
  categories: [
    {
      id: 'all',
      name: 'All',
      displayName: 'All Packages',
      enabled: true
    },
    {
      id: 'asia',
      name: 'Asia',
      displayName: 'Asia',
      enabled: true,
      description: 'Explore the diverse cultures and landscapes of Asia'
    },
    {
      id: 'europe',
      name: 'Europe',
      displayName: 'Europe',
      enabled: true,
      description: 'Discover the rich history and beauty of Europe'
    },
    {
      id: 'seasonal',
      name: 'Seasonal Packages',
      displayName: 'Seasonal Packages',
      enabled: true,
      description: 'Limited time offers and seasonal specials'
    },
    {
      id: 'domestic',
      name: 'Domestic',
      displayName: 'Domestic Packages',
      enabled: true,
      description: 'Explore the beauty of India with our curated domestic packages'
    }
  ],

  // Hero section settings
  hero: {
    title: 'Explore the World and Create Unforgettable Memories',
    subtitle: 'Book your travel and transportation service with us and enjoy a hassle-free and memorable journey',
    backgroundImage: '/assets/images/trips/istanbul/day1 -1.png'
  },

  // Site branding
  branding: {
    siteName: 'AirYouGo Vacations',
    tagline: 'Your Journey, Our Passion',
    primaryColor: '#0066cc',
    secondaryColor: '#0052a3'
  },

  // Company and contact information
  company: {
    name: 'AirYouGo Vacations',
    registeredAddress: '658, Vishwamanava Road, Saraswatipuram, Mysuru – 570026',
    phone: '+91 9900219291',
    alternatePhone: '+91 9900143767',
    whatsapp: '+91 9900219291',
    email: 'harika@airyougo.in',
    about: 'AirYouGo Vacations is a premium travel company specializing in curated international and domestic travel experiences. We design personalized itineraries, luxury holidays, honeymoon trips, family vacations, and group tours tailored to each client\'s preferences. With a focus on seamless planning, exclusive experiences, and trusted partnerships worldwide, AirYouGo Vacations ensures every journey is memorable, stress-free, and extraordinary. Our mission is to transform travel dreams into reality through expert guidance, premium service, and attention to detail. From Europe to Southeast Asia, luxury escapes to adventure journeys, AirYouGo Vacations is your trusted travel partner.'
  },

  // Social handles (add missing links later)
  social: {
    instagram: 'https://www.instagram.com/airyougovacations?igsh=eXl2bWU3Y3Vxbmg4&utm_source=qr',
    facebook: '',
    googleBusiness: ''
  },

  // FAQ content
  faqs: [
    {
      question: 'How do I book a package?',
      answer: 'Clients can contact us via WhatsApp, phone, Instagram, or website inquiry form.'
    },
    {
      question: 'Do you offer customized itineraries?',
      answer: 'Yes, all itineraries can be personalized based on client preferences, budget, and travel dates.'
    },
    {
      question: 'What payment methods do you accept?',
      answer: 'We accept bank transfer, UPI, online payment links, and credit card options (as applicable for each booking).'
    },
    {
      question: 'Do you provide visa assistance?',
      answer: 'Yes, visa guidance and assistance is provided for applicable destinations.'
    },
    {
      question: 'Are flights included in packages?',
      answer: 'It depends on the package. Both flight-inclusive and land-only packages are available.'
    },
    {
      question: 'What is your cancellation policy?',
      answer: 'Cancellation policy varies by destination, airline, and hotel. Exact terms are shared at booking.'
    },
    {
      question: 'Do you provide support during travel?',
      answer: 'Yes, we provide end-to-end assistance and on-trip support.'
    },
    {
      question: 'Do you offer honeymoon and luxury packages?',
      answer: 'Yes, honeymoon, babymoon, luxury, and premium travel packages are our specialty.'
    }
  ],

  // Features display
  features: [
    {
      icon: 'fa-headset',
      title: 'Support',
      description: 'Get 24/7 customer support for all your travel needs and queries'
    },
    {
      icon: 'fa-shield-alt',
      title: 'Security',
      description: 'Your data and payments are protected with industry-leading security'
    },
    {
      icon: 'fa-star',
      title: 'Quality',
      description: 'Experience premium quality services and hand-picked destinations'
    }
  ]
};

export default siteConfig;
